module.exports = __webpack_public_path__ + "static/media/offers.9149ee71.svg";